export default "__VITE_ASSET__ea6bc6d6__"